var App = App || {};

App.WidgetCategory = (function ($) {
    'use strict';
    
    function CompareInit() {
        const categoryWidgets = $(".widget.widget-category");

        if (categoryWidgets.length) {
            categoryWidgets.each(function () {
                var selector = $(this);

                // set up checkboxes functionality on load and reset when browser is resized through breakpoints
                if (selector.find(".widget-category-compare-controls").length) {
                    CompareCheckboxes(selector);
                    $(document).on("enter-xs enter-sm enter-md enter-lg enter-xl enter-xxl", function () {
                        CompareCheckboxes(selector);
                        ResizeSubheaders(selector);
                    });

                    onTableScroll(selector);
                }

                //ensure subheading resize when tab is opened
                var comparePane = selector.find('.compare-pane');
                if (comparePane.length) {
                    var paneId = comparePane.attr("id");
                    var compareButton = $("button[aria-controls=" + paneId + "]");
                    compareButton.on('shown.bs.tab', function () {
                        ResizeSubheaders(selector);
                    })
                }

                $(document).ready(function () {
                    ResizeSubheaders(selector);
                });

                setDataHeadHeight(selector);
            });
        }
    }

    function CompareCheckboxes(component) {

        var controls = component.find(".widget-category-compare-controls").find(".form-check-input");
        controls.on("change", function () {
            CompareCheckboxesUpdate(component);
            ResizeSubheaders(component);
        });

        const checkboxLimitsMax = CompareCheckboxesBasedOnBp().max;
        controls.prop("checked", false);
        controls.slice(0, checkboxLimitsMax).prop("checked", true);

        const controlPanel = controls.parents(".widget-category-compare-controls");
        if (controls.length <= checkboxLimitsMax) { controlPanel.hide(); }
        else { controlPanel.show(); }

        CompareCheckboxesUpdate(component);
    }

    function CompareCheckboxesUpdate(component) {

        const controls = component.find(".widget-category-compare-controls");
        const controlsChecked = controls.find("input:checked");
        const controlsUnchecked = controls.find("input:not(:checked)");
        const columnsShown = [];
        const $tableHead = component.find(".table-head");

        // disable checkboxes to enforce minimum and maximum checked
        const checkboxLimits = CompareCheckboxesBasedOnBp();

        if (controlsChecked.length >= checkboxLimits.max) {
            controlsUnchecked.attr("disabled", true);
        }
        else {
            controlsUnchecked.attr("disabled", false);
        }
        if (controlsChecked.length <= checkboxLimits.min) {
            controlsChecked.attr("disabled", true);
        }
        else {
            controlsChecked.attr("disabled", false);
        }

        // show/hide content based on checked controls
        controlsChecked.each(function () {
            columnsShown.push($(this).attr("id"));
        });

        component.find("[data-controlledby]").each(function () {
            var control = $(this).attr("data-controlledby");
            if (columnsShown.includes(control)) { $(this).show(); }
            else { $(this).hide(); }
        });

        setDataHeadHeight($tableHead);
    }

    function CompareCheckboxesBasedOnBp() {

        let result;

        switch (ZagBreakpoints.GetBreakpoint()) {
            case 'xxl': result = { max: 4, min: 1 }; break;
            case 'xl': result = { max: 4, min: 1 }; break;
            case 'lg': result = { max: 3, min: 1 }; break;
            case 'md': result = { max: 3, min: 1 }; break;
            default: result = { max: 2, min: 1 };
        }
        return result;

    }

    function ResizeSubheaders(component) {
        var subHeaders = component.find(".table-cell-subheader")
        var headRow = component.find(".table-head .table-row");
        var headCells = component.find(".table-head .table-cell");
        var tableWidth = 0;
        var visibleColCount = 0;

        headCells.each(function () {
            if ($(this).css("display") != "none") {
                tableWidth += $(this).outerWidth();
                visibleColCount++;
            }
        });
        tableWidth += (visibleColCount - 1) * parseInt(headRow.css("gap"));
        subHeaders.outerWidth(tableWidth);
    }

    function onTableScroll(selector) {
        var $compareTable = selector.find(".widget-category-compare-table");
        var $tableHead = $compareTable.find(".table-head");
        var $tableHeadPlaceholder = $compareTable.find(".table-head-placeholder");
        var $tableBody = $compareTable.find(".table-body");

        $(window).on('scroll', function () {

            if (!$compareTable.closest(".tab-pane").length > 0 || $compareTable.closest(".tab-pane").hasClass("active")) {
                var windowTop = $(window).scrollTop(),
                    tableTop = $compareTable.offset().top,
                    tableBottom = tableTop + $compareTable.outerHeight(),
                    bodyTop = $tableBody.offset().top;

                setDataHeadHeight(selector);

                if (windowTop > tableTop) {
                    $tableHead.addClass("scrolling").find(".header-tag-wrapper").attr("aria-hidden", true);
                    $tableHeadPlaceholder.outerHeight($tableHead.attr("data-init-height"));
                } else if (windowTop < bodyTop - $tableHead.attr("data-init-height")) {
                    $tableHead.removeClass("scrolling").find(".header-tag-wrapper").attr("aria-hidden", false);
                    $tableHeadPlaceholder.outerHeight(0);
                }
            }
        });
    }

    function setDataHeadHeight(selector) {
        var $tableHead = selector.find(".widget-category-compare-table .table-head")
        if (!$tableHead.closest(".tab-pane").length > 0 || $tableHead.closest(".tab-pane").hasClass("active")) {
            if (!$tableHead.hasClass("scrolling")) {
                $tableHead.attr("data-init-height", $tableHead.outerHeight());
            }
        }
    }

    return {
        CompareInit: CompareInit
    };

})(jQuery);

$(function () {
    App.WidgetCategory.CompareInit();
}); 